import React, { Component } from 'react';
import moment from 'moment';
import 'moment-duration-format';
import BuildSettings from '../../buildSettings';
import globals from 'APP_ROOT/components/common/globals';
import AccountUtil from '../../common/accountUtil';
import EditPlanModal from './editPlanModal';
import ShareRavenModal from './shareRavenModal';
import RemoveSharedRavenModal from './removeSharedRavenModal';
import RescindSharedRavenAccessModal from './rescindSharedRavenAccessModal';
import DataWidget from './DataWidget/DataWidget';
import { strings } from '../../../localization';

export default class RavenCard extends Component {

    constructor(props) {

        super(props);

        this.state = {
        };
    }

    componentDidMount() {

        if (this.props.raven && this.props.raven.ravenUuid) {
            // Check if our URL says we need to open a plan modal
            var myRe = /\?edit=(\w+)/g;
            var myArray = myRe.exec(window.location.search);

            if (myArray && myArray.length > 1) {
                var uuid = myArray[1];
                if (this.props.raven.ravenUuid === uuid) {
                    this.openEditPlanModal();
                }
            }
        }
    }

    openRescindAccessModal = (e, user) => {

        e.preventDefault();
        document.documentElement.classList.add("no-scroll");

        var rescindAccessModalOpen = this.state.rescindAccessModalOpen;
        if(!rescindAccessModalOpen) { rescindAccessModalOpen = {} }
        rescindAccessModalOpen[user.email] = true;

        this.setState({
            rescindAccessModalOpen: rescindAccessModalOpen,
            rescindUser: user
        });
    }

    closeRescindAccessModal = (e, user) => {

        e.preventDefault();
        document.documentElement.classList.remove("no-scroll");

        var rescindAccessModalOpen = this.state.rescindAccessModalOpen;
        if(!rescindAccessModalOpen) { rescindAccessModalOpen = {} }
        rescindAccessModalOpen[user.email] = false;

        this.setState({
            rescindAccessModalOpen: rescindAccessModalOpen,
            rescindUser: null
        });
    }

    openRemoveSharedRavenModal = (e) => {

        e.preventDefault();
        document.documentElement.classList.add("no-scroll");
        this.setState({
            removeSharedRavenModalOpen: true
        });
    }

    closeRemoveSharedRavenModal = (e) => {

        e.preventDefault();
        document.documentElement.classList.remove("no-scroll");
        this.setState({
            removeSharedRavenModalOpen: false
        });
    }

    //Share Raven with Another User Modal
    openShareRavenModal = (e, index) => {

        e.preventDefault();
        document.documentElement.classList.add("no-scroll");
        this.setState({
            shareRavenModalOpen: true
        });
    }

    closeShareRavenModal = (e) => {

        e.preventDefault();
        document.documentElement.classList.remove("no-scroll");
        this.setState({
            shareRavenModalOpen: false
        });
    }

    openEditPlanModal = (e) => {

        if (e) e.preventDefault();
        document.documentElement.classList.add("no-scroll");
        this.setState({
            editPlanModalOpen: true
        });
    }

    closeEditPlanModal = (e) => {

        if (e) e.preventDefault();
        document.documentElement.classList.remove("no-scroll");
        this.setState({
            editPlanModalOpen: false
        });
    }

    renderOwnedRavenSection(subscription) {

        var buttonDisabled = window.recurly ? false : true;

        var ravenUserList = this.props.raven.ravenUsers.map((user, index) => {
            var driverName = user.driverName ? user.driverName : '';
            var email = user.email ? user.email : strings.formatString(strings.unknown_user);
            return (
                <div className="user-item" key={index}>
                    <i className="material-icons blue icon-sm">person</i>
                    <div>
                        <h5>{driverName === '' ? email : driverName}</h5>
                        <p>{email}</p>
                    </div>
                    <a className="btn btn-outline-blue btn-sm" onClick={(e) => this.openRescindAccessModal(e, user)}><i className="material-icons">remove_circle_outline</i>{strings.formatString(strings.remove_access)}</a>
                    <RescindSharedRavenAccessModal {...this.props} {...this.state}
                        closeRescindAccessModal={(e) => this.closeRescindAccessModal(e, user) }
                        rescindAccessModalOpen={this.state.rescindAccessModalOpen && this.state.rescindAccessModalOpen[email]}
                        email={email} />
                </div>
            );
        });
        var ravenUserSection = ravenUserList.length > 0 ?
            (
                <div className="row shared-user-list">
                    <div className="col-12">
                        {ravenUserList}
                    </div>
                </div>
            ) : (
                <p>{strings.formatString(strings.raven_not_shared_message)}</p>
            );

        if(this.props.features.show_service_plan)
        {
            return (
            <div className="col-12 owned-raven-section">
                <div className="row">
                    {
                        BuildSettings.billingEnabled && subscription && subscription.planCode !== "nsp" ?
                            (
                                <div className="col-12 plan-info">
                                    <div className="row">
                                        {this.renderDataUsage(subscription)}
                                        {this.renderSubscriptionDetails(subscription)}
                                        <div className="col-12 button-row">
                                            { 
                                                // first see if we should display the button at all
                                                // then see if it is disabled due to no recurly JS or not
                                                (subscription.pendingSub || subscription.planSelectionRequired || !subscription.noLimitPlan) ? (buttonDisabled ?
                                                <button className="btn" onClick={this.openEditPlanModal} disabled title="Enable Javascript to edit service plan"><i className="material-icons">edit</i>{strings.raven_subscription_edit_plan_action}</button> :
                                                <button className="btn" onClick={this.openEditPlanModal}><i className="material-icons">edit</i>{strings.raven_subscription_edit_plan_action}</button>) : null
                                            }
                                            <EditPlanModal {...this.props} {...this.state}
                                                closeEditPlanModal={this.closeEditPlanModal}
                                                subscription={subscription}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : this.renderNoSubSection(subscription)
                    }
                    {!this.props.mobileVersion && !this.props.raven.noServicePlan ? (
                        <div className="col-12 trusted-circle">
                            <h4><i className="material-icons">supervised_user_circle</i>{strings.formatString(strings.trusted_circle_title)}</h4>
                            {ravenUserSection}
                            <div className="button-row">
                                <button className="btn" onClick={this.openShareRavenModal}><i className="material-icons">email</i>{strings.formatString(strings.invite_user)}</button>
                                <ShareRavenModal {...this.props} {...this.state} closeShareRavenModal={this.closeShareRavenModal} stage={this.props.user?.stage} />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            );
        }
        else
        {
            return (
            <div className="col-12 owned-raven-section">
                <div className="row">
                    <div className="col-12 plan-info">
                        <div className="row">
                            {this.renderFleetServicePlan()}
                        </div>
                    </div>
                    {!this.props.mobileVersion && !this.props.raven.noServicePlan ? (
                        <div className="col-12 trusted-circle">
                            <h4><i className="material-icons">supervised_user_circle</i>{strings.formatString(strings.trusted_circle_title)}</h4>
                            {ravenUserSection}
                            <div className="button-row">
                                <button className="btn" onClick={this.openShareRavenModal}><i className="material-icons">email</i>{strings.formatString(strings.invite_user)}</button>
                                <ShareRavenModal {...this.props} {...this.state} closeShareRavenModal={this.closeShareRavenModal} stage={this.props.user?.stage} />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            );
        }
    }

    //could represent actually no subscription OR plancode == nsp
    renderNoSubSection(subscription) {

        var buttonDisabled = window.recurly ? false : true;

        return (
            <div className="col-12 plan-info">
                <p><i className="material-icons yellow">warning</i>{strings.formatString(strings.no_plan_message)}</p>
                <div className="button-row">
                    {this.props.accountDetails ? (
                        buttonDisabled ?
                            <button className="btn" onClick={this.openEditPlanModal} disabled title="Enable Javascript to start a service plan"><i className="material-icons">edit</i>{strings.raven_subscription_start_a_service_plan}</button> :
                            <button className="btn" onClick={this.openEditPlanModal}><i className="material-icons">edit</i>{strings.raven_subscription_start_a_service_plan}</button>) : null}
                    <EditPlanModal {...this.props} {...this.state}
                        closeEditPlanModal={this.closeEditPlanModal}
                        subscription={subscription}
                    />
                </div>
            </div>
        )
    }

    renderFleetServicePlan() {
        return (
            <div className="col-12 plan-details">
                <p>{strings.raven_subscription_to_change_plan_please_contact_label} <a href={"mailto:" + globals.salesEmail}>{globals.salesEmail}</a></p>
            </div>
        );
    }

    renderGuestRavenSection(ownerUser) {

        if (ownerUser)
            return (
                <div className="col-12">
                    <div className="row">
                        <div className="col-12 col-md-5">
                            <label htmlFor="ownerName">{strings.formatString(strings.owner_name)}</label>
                            <p>{ownerUser.driverName}</p>
                        </div>

                        <div className="col-12 col-md-7">
                            <label htmlFor="ownerName">{strings.formatString(strings.owner_email)}</label>
                            <p>{ownerUser.email}</p>
                        </div>

                        <div className="col-12">
                            <div className="button-row">
                                <button className="btn btn-outline-blue" onClick={this.openRemoveSharedRavenModal}><i className="material-icons">remove_circle_outline</i>{strings.formatString(strings.remove_raven)}</button>
                                <RemoveSharedRavenModal {...this.props} {...this.state} closeRemoveSharedRavenModal={this.closeRemoveSharedRavenModal} />
                            </div>
                        </div>
                    </div>
                </div>
            );
    }

    renderDataUsage(subscription) {

        const planTotalSizeBytes = subscription.planData;
        if (!planTotalSizeBytes && planTotalSizeBytes !== 0) {
            console.error("Account Raven subscription invalid planData property");
            return null;
        }
        const dataUsageDetails = subscription.dataUsage? subscription.dataUsage : null;
        if (dataUsageDetails === null) { // 0 is a valid usage! check for 'null'
            console.error("Account Raven subscription invalid dataUsage property");
            return null;
        }

        const dataUsageGrandTotalBytes = dataUsageDetails.used;
        if (dataUsageGrandTotalBytes === null) { // 0 is a valid usage! check for 'null'
            console.error("Account Raven subscription dataUsage invalid used property");
            return null;
        }

        const dataUsageGrandTotalAvailable = dataUsageDetails.available;
        if (!dataUsageGrandTotalAvailable && dataUsageGrandTotalAvailable !== 0) {
            console.error("Account Raven subscription dataUsage invalid available property");
            return null;
        }

        const topUps = dataUsageDetails.topups? dataUsageDetails.topups : [];
        if (!dataUsageDetails.topups) {
            console.error("Account Raven subscription dataUsage invalid topups property"); // tops up should at least be an empty array
            // no return (we still have enough to at least show what the customer has used while we fix the problem)
        }

        const usedMBNoDecimalPlace = Math.round(dataUsageGrandTotalBytes/1000000);
        const availableGBOneDecimalPlace = Math.round((dataUsageGrandTotalAvailable/1000000000) * 10) / 10;

        var dateUsageSummary = strings.formatString(strings.data_usage_0_mb_of_1_gb_used_so_far, usedMBNoDecimalPlace, availableGBOneDecimalPlace);
        if (usedMBNoDecimalPlace >= 1000) { // checking value when rounded to the nearest MB (twilio-style/1000-MB GBs)
            const usedGBOneDecimalPlace = Math.round((dataUsageGrandTotalBytes/1000000000) * 10) / 10;
            dateUsageSummary = strings.formatString(strings.data_usage_0_gb_of_1_gb_used_so_far, usedGBOneDecimalPlace, availableGBOneDecimalPlace);
        }
        var totalTopupsUsedMessage = null;
        if (dataUsageDetails.topups && dataUsageDetails.topups.length > 0) {
            totalTopupsUsedMessage = strings.formatString(strings.data_usage_includes_0_top_ups, dataUsageDetails.topups.length);
        }

        try {
            if (subscription.planCode !== "nsp") {

                var limitReachedMessage = subscription.streamingRemaining <= 0 ? <span className="red"><i className="material-icons yellow">warning</i>{strings.formatString(strings.data_limit_reached)}</span> : null;
                return (
                    <div className="col-12 data-usage">
                        <div>
                            <h4><i className="material-icons">data_usage</i>{strings.formatString(strings.data_usage_title)}</h4>
                            <p>{dateUsageSummary} {totalTopupsUsedMessage} {limitReachedMessage}</p>
                            <DataWidget
                                dataUsageGrandTotalBytes={dataUsageGrandTotalBytes}
                                dataUsageGrandTotalAvailable={dataUsageGrandTotalAvailable}
                                planTotalSizeBytes={planTotalSizeBytes}
                                topUps={topUps}
                            />
                            <p>{!subscription.noLimitPlan ? strings.formatString(strings.data_top_up_warning) : null}</p>
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        } catch (e) {
            console.error(e);
            return null
        }
    }

    renderSubscriptionDetails(subscription) {

        if (subscription && subscription.planCode !== "nsp") {
            var priceString = subscription.amountInCents.toString();
            var planPrice = parseFloat(subscription.amountInCents) === 0 ? 'FREE' : priceString.slice(0, priceString.length - 2) + '.' + priceString.slice(priceString.length - 2, priceString.length);
            var planTitle = subscription.planCode;
            if (strings["plan_title_" + subscription.planCode]) planTitle = strings.formatString(strings["plan_title_" + subscription.planCode]);

            var addOns = null;
            try {
                if (subscription.addons) addOns = subscription.addOns.map((addOn, i) => {
                    return (
                        <tr key={i}>
                            <td><label>{strings.raven_subscription_details_add_on_label} - {addOn.type}</label></td>
                            <td><p>{addOn.price === 'FREE' ? addOn.price : '$' + addOn.price + " USD"}</p></td>
                        </tr>
                    )
                })
            } catch (e) {
                console.warn("failed to render add ons", e);
            }

            var pendingSubscription = undefined;
            if (this.props.accountDetails) {
                pendingSubscription = this.props.accountDetails.subscriptions.find(sub => {
                    return sub.state === 'pending' && sub.subscriptionUuid === subscription.subscriptionUuid;
                });
            }
            var pendingSubSection = null;
            if (pendingSubscription) {
                var pendingSubTitle = pendingSubscription.planCode;
                if (strings["plan_title_" + pendingSubscription.planCode]) pendingSubTitle = strings.formatString(strings["plan_title_" + pendingSubscription.planCode]);
                // var pendingPriceString = pendingSubscription.amountInCents.toString();
                // var pendingPlanPrice = parseFloat(pendingSubscription.amountInCents) === 0 ? 'FREE' : pendingPriceString.slice(0, pendingPriceString.length - 2) + '.' + pendingPriceString.slice(pendingPriceString.length - 2, pendingPriceString.length);
                // pendingSubSection = (
                //     <div>
                //         <h5>Next Plan</h5>
                //         <table className="pricing-table">
                //             <tbody>
                //                 <tr>
                //                     <td><label>Next Plan - {pendingSubTitle}</label></td>
                //                     <td><p>{pendingPlanPrice === 'FREE' ? pendingPlanPrice : '$' + pendingPlanPrice + " USD"}</p></td>
                //                 </tr>
                //             </tbody>
                //         </table>
                //         <p>Your plan will change at the beginning of the next billing cycle ({moment(subscription.currentBillingPeriod.end).format('LL')})</p>
                //     </div>
                // )
                pendingSubSection = <p>{strings.raven_subscription_your_plan_will_change_to} <span className="blue">{pendingSubTitle}</span>.</p>
            }

            return (
                <div className="col-12 plan-details">
                    <h4><i className="material-icons">assignment</i>{strings.raven_current_billing_period_title}</h4>
                    <p className="gray">{moment(subscription.currentBillingPeriod.start).format('LL')} - {moment(subscription.currentBillingPeriod.end).format('LL')}</p>
                    <p>{strings.raven_subscription_your_current_service_plan_is} <span className="blue">{planTitle}</span>.</p>
                    {!pendingSubscription ?
                        <p>{strings.raven_subscription_your_plan_will_auto_renew_at_the_end_of_the_current_billing_cycle}</p>
                        : <p>{strings.raven_subscription_your_plan_will_change_to} <span className="blue">{pendingSubTitle}</span></p>
                    }
                    {subscription.state === 'canceled' ?
                        <p><i className="material-icons yellow">warning</i><span className="yellow text-bold">{strings.raven_subscription_plan_canceled}</span> {strings.raven_subscription_plan_canceled_description}</p>
                        : null}
                </div>
            );
        } else {
            return null;
        }
    }

    render() {

        var ownerUser = this.props.raven.ravenUsers ? this.props.raven.ravenUsers.find((user, index) => {
            if (user.accessLevel === "OWNER") return user;
        }) : null;

        //if no subscription for raven, check if not owned, then
        //render as not owned raven instead. (no plan info, 'shared' label)
        var shareSection = null;
        if (!this.props.mobileVersion) {
           if(this.props.raven.canEdit) {
                    shareSection = <h4 className="header-label"><i className="material-icons">person</i>{strings.formatString(strings.raven_owned_title)}</h4>;
           } else {
                   shareSection = <h4 className="header-label"><i className="material-icons">share</i>{strings.formatString(strings.raven_shared_title)}</h4>
           }
        }

        var subscription = null;
        if (BuildSettings.billingEnabled && this.props.accountDetails && this.props.accountDetails.subscriptions) {
            subscription = AccountUtil.getRavenActiveSubscription(this.props.raven.ravenUuid, this.props.accountDetails.subscriptions);
        }

        var ravenCardClasses = ["raven-card"];
        if (subscription && subscription.planSelectionRequired) ravenCardClasses.push("trial-ending");
        else if (subscription && subscription.state === 'canceled') ravenCardClasses.push("canceled");
        else if (subscription && subscription.planCode === 'nsp') ravenCardClasses.push("no-service-plan");

        return (
            <div className="col-12 raven-group">
                <div className={ravenCardClasses.join(" ")}>
                    {subscription && subscription.planSelectionRequired ? (
                        <a onClick={this.openEditPlanModal} className="card-banner"><i className="material-icons">error_outline</i>{strings.formatString(strings.raven_free_trial_message, moment(subscription.currentBillingPeriod.end).fromNow())}</a>
                    ) : null}
                    {subscription && subscription.state === 'canceled' ? (
                        <div className="card-banner"><i className="material-icons">warning</i>{strings.raven_subscription_your_plan_is_canceled}</div>
                    ) : null}
                    {subscription && subscription.planCode === 'nsp' ? (
                        <div className="card-banner"><i className="material-icons">warning</i>{strings.raven_subscription_youve_selected_no_Service_plan}</div>
                    ) : null}
                    <div className="row">
                        <div className="col-8">
                            <label htmlFor="">{strings.raven_name}</label>
                            <h3 className="header-with-btn">{this.props.raven.vehicle ? this.props.raven.vehicle.name : null}</h3>
                        </div>

                        <div className="col-4">
                            {shareSection}
                        </div>

                        {this.props.raven.canEdit ? this.renderOwnedRavenSection(subscription) : this.renderGuestRavenSection(ownerUser)}
                    </div>
                </div>
            </div>
        );
    }
}
